//@flow
import {
    REFRESH_GORGON_FORMS_SUCCESS,
    REFRESH_GORGON_FORMS_ERROR,
    REFRESH_GORGON_FORM_QUESTIONS_SUCCESS,
    REFRESH_GORGON_FORM_QUESTIONS_ERROR,
    GORGON_DOC_SUBMIT_SUCCESS,
    GORGON_DOC_SUBMIT_ERROR,
    GORGON_DOC_SUBMITTED_COMPLETED,
    UPDATE_SELECTED_GORGON_FORM_NUM,
    CLEAR_SELECTED_GORGON_FORM_NUM,
    GORGON_FORM_PANEL_EXPANDABLE_ADD,
    GORGON_FORM_PANEL_EXPANDABLE_REMOVE,
    UPDATE_GORGON_FORM_ERROR,
    ADD_GORGON_FORM_APP_COVERAGE_LINE,
    REMOVE_GORGON_FORM_APP_COVERAGE_LINE,
    GORGON_PANEL_PDF_CONTENT,
    EDIT_VERIFY_FORM_DATA_ERROR,
    EDIT_VERIFY_FORM_DATA_SUCCESS
} from './actionTypes';
import reduce from '../reduce';
import type { ReducerState,ReducerAction,ReducerFormAppCoverage } from './flowTypes'

const initialState:ReducerState = {
    forms: [],
    isFormsLookupLoaded: false,
    formQuestions: [],
    error: '',
    docSubmitted: false,
    anyChanges: false,
    form: null,
    formChanges: false,
    memEmpTypes: [
        { code: 'Member/Employee', desc: 'Member/Employee'},
        { code: 'Spouse', desc: 'Spouse'},
        { code: 'Child', desc: 'Child'}
    ],
    states: [
        { code: 'AL', name: 'AL - Alabama'},{ code: 'AK', name: 'AK - Alaska'},
        { code: 'AZ', name: 'AZ - Arizona'},{ code: 'AR', name: 'AR - Arkansas'},
        { code: 'AS', name: 'AS - American Samoa'},
        { code: 'CA', name: 'CA - California'},{ code: 'CO', name: 'CO - Colorado'},
        { code: 'CT', name: 'CT - Connecticut'},{ code: 'DE', name: 'DE - Delaware'},
        { code: 'DC', name: 'DC - District of Columbia'},{ code: 'FL', name: 'FL - Florida'},
        { code: 'GA', name: 'GA - Georgia'},{ code: 'HI', name: 'HI - Hawaii'},
        { code: 'GU', name: 'GU - Guam'},
        { code: 'ID', name: 'ID - Idaho'},{ code: 'IL', name: 'IL - Illinois'},
        { code: 'IN', name: 'IN - Indiana'},{ code: 'IA', name: 'IA - Iowa'},
        { code: 'KS', name: 'KS - Kansas'},{ code: 'KY', name: 'KY - Kentucky'},
        { code: 'LA', name: 'LA - Louisiana'},{ code: 'ME', name: 'ME - Maine'},
        { code: 'MD', name: 'MD - Maryland'},{ code: 'MA', name: 'MA - Massachusetts'},
        { code: 'MI', name: 'MI - Michigan'},{ code: 'MN', name: 'MN - Minnesota'},
        { code: 'MS', name: 'MS - Mississippi'},{ code: 'MO', name: 'MO - Missouri'},
        { code: 'MT', name: 'MT - Montana'},{ code: 'MH', name: 'MH - Marshall Islands'},
        { code: 'FM', name: 'FM - Micronesia'},{ code: 'NE', name: 'NE - Nebraska'},
        { code: 'NV', name: 'NV - Nevada'},{ code: 'NH', name: 'NH - New Hampshire'},
        { code: 'NJ', name: 'NJ - New Jersey'},{ code: 'NM', name: 'NM - New Mexico'},
        { code: 'NY', name: 'NY - New York'},{ code: 'NC', name: 'NC - North Carolina'},
        { code: 'ND', name: 'ND - North Dakota'},{ code: 'MP', name: 'MP - Northern Marianas'},
        { code: 'OH', name: 'OH - Ohio'},
        { code: 'OK', name: 'OK - Oklahoma'},{ code: 'OR', name: 'OR - Oregon'},
        { code: 'PA', name: 'PA - Pennsylvania'},{ code: 'PW', name: 'PW - Palau'},
        { code: 'PR', name: 'PR - Puerto Rico'},{ code: 'RI', name: 'RI - Rhode Island'},
        { code: 'SC', name: 'SC - South Carolina'},{ code: 'SD', name: 'SD - South Dakota'},
        { code: 'TN', name: 'TN - Tennessee'},{ code: 'TX', name: 'TX - Texas'},
        { code: 'UT', name: 'UT - Utah'},{ code: 'VT', name: 'VT - Vermont'},
        { code: 'VA', name: 'VA - Virginia'},{ code: 'VI', name: 'VI - Virgin Islands'},
        { code: 'WA', name: 'WA - Washington'},
        { code: 'WV', name: 'WV - West Virginia'},{ code: 'WI', name: 'WI - Wisconsin'},
        { code: 'WY', name: 'WY - Wyoming'}
    ],
    countries: [
        { code: 'US', name: 'US'}
    ],
    genders: [
        { code: 'M', name: 'Male'},{ code: 'F', name: 'Female'}
    ],
    applicationTypes: [
        { code: 'Empty', name: 'Not Found'},{ code: 'Initial', name: 'Initial'},
        { code: 'Increase In Coverage', name: 'Increase In Coverage'},
        { code: 'Late Application', name: 'Late Application'}
    ],
    formExpandedPanels: [GORGON_PANEL_PDF_CONTENT],
    panelUpdateTimestamp: null,
    formError: {},
    formAppCoverages: [{formId: 1}],
    refreshedFormAppCoverageTimestamp: null,
    formData: {},
    formNumPopulated: false,
    reviewQuestions: []
}

const refreshedForms = (state: ReducerState,action: ReducerAction)=>{
    return {
        ...state,
        forms: action.forms,
        isFormsLookupLoaded: true
    }
}

const refreshedFormsError = (state: ReducerState,action: ReducerAction)=> {
    return {
        ...state,
        error: action.error
    }
}

const refreshedFormQuestions = (state:ReducerState,action: ReducerAction)=>{
    return {
        ...state,
        formQuestions: action.formQuestions,
        formChanges: false,
        formNumPopulated: false
    }
}

const refreshedFormQuestionsError = (state:ReducerState,action: ReducerAction)=> {
    return {
        ...state,
        error: action.error,
        //formNumChanges: false
    }
}

const docSubmittedSuccess = (state:ReducerState) => {
    return {
        ...state,
        docSubmitted: true,
        error: '',
    }
}

const docSubmittedError = (state:ReducerState,action: ReducerAction) => {
    return {
        ...state,
        error: action.error
    }
}

const docSubmittedCompleted = (state:ReducerState) => {
    return {
        ...state,
        invoiceSubmitted: false
    }
}

const updateSelectedForm = (state:ReducerState,action:ReducerAction)=>{
    return {
        ...state,
        form: action.form,
        formChanges: true
    }
}

const clearSelectedFormNum=(state:ReducerState)=>{
    return {
        ...state,
        formQuestions: []
    }
}

const addFormPanel=(state:ReducerState,action:ReducerAction)=>{
    let formalPanels=state.formExpandedPanels;
    formalPanels.push(action.panel)
    
    return {
        ...state,
        formExpandedPanels: formalPanels,
        panelUpdateTimestamp: new Date()
    }
}

const removeFormPanel=(state:ReducerState,action:ReducerAction)=>{
    let formalPanels=state.formExpandedPanels;
    formalPanels=formalPanels.filter((item) => item != action.panel )
    
    return {
        ...state,
        formExpandedPanels: formalPanels,
        panelUpdateTimestamp: new Date()
    }
}

const updateFormError=(state:ReducerState,action:ReducerAction)=>{
    return {
        ...state,
        formError: action.formError
    }
}

const addFormAppCoverageLine=(state:ReducerState)=>{
    let formAppCoverages:Array<ReducerFormAppCoverage> = state.formAppCoverages
    let lastForm:ReducerFormAppCoverage = formAppCoverages[formAppCoverages.length -1 ]
    let newForm:ReducerFormAppCoverage = {
        formId: lastForm.formId + 1
    }
    
    formAppCoverages.push(newForm)

    return {
        ...state,
        formAppCoverages: formAppCoverages,
        refreshedFormAppCoverageTimestamp: new Date()
    }
}

const removeFormAppCoverageLine=(state:ReducerState,action:ReducerAction)=>{
    let formAppCoverages:Array<ReducerFormAppCoverage> = state.formAppCoverages
    formAppCoverages = formAppCoverages.filter(item => item.formId != action.formId)
    
    return {
        ...state,
        formAppCoverages: formAppCoverages,
        refreshedFormAppCoverageTimestamp: new Date()
    }
}

const editVerifyFormDataSuccess=(state:ReducerState,action:ReducerAction)=>{
    return {
        ...state,
        error: '',
        formData: action.formData,
        formNumPopulated: true,
        formQuestions: action.formQuestions,
        reviewQuestions: action.reviewQuestions,
        formAppCoverages: action.formAppCoverages
    }
}

const editVerifyFormDataError=(state:ReducerState,action:ReducerAction)=>{
    return {
        ...state,
        error: action.error
    }
}

export default reduce(initialState,{
    [REFRESH_GORGON_FORMS_SUCCESS]: refreshedForms,
    [REFRESH_GORGON_FORMS_ERROR]: refreshedFormsError,
    [REFRESH_GORGON_FORM_QUESTIONS_SUCCESS]: refreshedFormQuestions,
    [REFRESH_GORGON_FORM_QUESTIONS_ERROR]: refreshedFormQuestionsError,
    [GORGON_DOC_SUBMIT_SUCCESS]: docSubmittedSuccess,
    [GORGON_DOC_SUBMIT_ERROR]: docSubmittedError,
    [GORGON_DOC_SUBMITTED_COMPLETED]: docSubmittedCompleted,
    [UPDATE_SELECTED_GORGON_FORM_NUM]: updateSelectedForm,
    [CLEAR_SELECTED_GORGON_FORM_NUM]: clearSelectedFormNum,
    [GORGON_FORM_PANEL_EXPANDABLE_ADD]: addFormPanel,
    [GORGON_FORM_PANEL_EXPANDABLE_REMOVE]: removeFormPanel,
    [UPDATE_GORGON_FORM_ERROR]: updateFormError,
    [ADD_GORGON_FORM_APP_COVERAGE_LINE]: addFormAppCoverageLine,
    [REMOVE_GORGON_FORM_APP_COVERAGE_LINE]: removeFormAppCoverageLine,
    [EDIT_VERIFY_FORM_DATA_ERROR]: editVerifyFormDataError,
    [EDIT_VERIFY_FORM_DATA_SUCCESS]: editVerifyFormDataSuccess
});


// WEBPACK FOOTER //
// ./src/redux/gorgon/reducer.js